export default __webpack_public_path__ + "static/media/weight.242e6329.svg";